import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Link } from '@mui/material';
import scribeLogo from '../../static/scribeLogo2.svg'

const PREFIX = 'TutorialModal';

const classes = {
  root: `${PREFIX}-root`,
  heading: `${PREFIX}-heading`,
  accordion: `${PREFIX}-accordion`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },

  [`& .${classes.heading}`]: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightBold,
  },

  [`& .${classes.accordion}`]: {
      margin: theme.spacing(1, 0),
    }
}));

// ====== Update Here Once Scribe is FINSIHED ==========
const scribeURL = `https://scribehow.com/shared/Project_Health_Dashboard_PHD__QIjB8iH3Tsq8igtQYw0UgA`


const TutorialModal = ({ title }) => {


    return (
      <Root>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Link
        id="link-5"
        href={scribeURL}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
        }}
        >
        <Typography
          variant="subtitle1"
          className="titillium-web project-header-title-text"
          style={{
          color: 'white',
          textDecoration: 'underline',
          cursor: 'pointer',
          fontSize: '1rem',
          marginLeft: '8px',
          marginRight: '8px',
          }}
        >
          Tutorial
        </Typography>

        <img
          src={scribeLogo}
          className="project-link-icon"
          alt="Scribe"
          title="Open Scribe for PHD"
          style={{
            verticalAlign: 'middle',
            marginLeft: '-2px',
            width: 18, height: 18,
            marginRight: '10px',
          }}
        />
        </Link>
      </div>
      </Root>
    );
};

export default TutorialModal;
